"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Pagination = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactUi = require("@100mslive/react-ui");
var _reactIcons = require("@100mslive/react-icons");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
var Pagination = function Pagination(_ref) {
  var page = _ref.page,
    setPage = _ref.setPage,
    numPages = _ref.numPages;
  var disableLeft = page === 0;
  var disableRight = page === numPages - 1;
  var nextPage = function nextPage() {
    setPage(Math.min(page + 1, numPages - 1));
  };
  var prevPage = function prevPage() {
    setPage(Math.max(page - 1, 0));
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.StyledPagination.Root, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.StyledPagination.Chevron, {
      disabled: disableLeft,
      onClick: prevPage,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIcons.ChevronLeftIcon, {
        width: 16,
        height: 16,
        style: {
          cursor: disableLeft ? "not-allowed" : "pointer"
        }
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.StyledPagination.Dots, {
      children: _toConsumableArray(Array(numPages)).map(function (_, i) {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.StyledPagination.Dot, {
          active: page === i,
          onClick: function onClick() {
            return setPage(i);
          }
        }, i);
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.StyledPagination.Chevron, {
      disabled: disableRight,
      onClick: nextPage,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIcons.ChevronRightIcon, {
        width: 16,
        height: 16,
        style: {
          cursor: disableRight ? "not-allowed" : "pointer"
        }
      })
    })]
  });
};
exports.Pagination = Pagination;